function closeAllDesktopSubpanels(nav) {
  nav.querySelectorAll('.overcategory-nav__desktop-shell').forEach((shell) => {
    shell.classList.remove('has-active-subpanel');
  });

  nav.querySelectorAll('[data-desktop-subpanel-target]').forEach((button) => {
    button.classList.remove('is-active');
  });

  nav.querySelectorAll('[data-desktop-subpanel]').forEach((panel) => {
    panel.classList.remove('is-active');
  });

  const drawer = document.getElementById('header-sidebar-menu');
  if (drawer) {
    drawer.classList.remove('has-active-subpanel');
  }
}

function closeAllMobileSubpanels(nav) {
  nav.querySelectorAll('[data-mobile-subpanel]').forEach((panel) => {
    panel.classList.remove('is-active');
  });
}

function resetDrawerPanels(drawer) {
  drawer.querySelectorAll('[data-overcategory-nav]').forEach((nav) => {
    closeAllDesktopSubpanels(nav);
    closeAllMobileSubpanels(nav);

    nav.querySelectorAll('[data-root-panel]').forEach((panel, index) => {
      panel.classList.toggle('is-active', index === 0);
    });

    nav.querySelectorAll('.overcategory-nav__tab').forEach((tab, index) => {
      const active = index === 0;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  });

  drawer.classList.remove('has-active-subpanel');
}

document.addEventListener('click', function (event) {
  const nav = event.target.closest('[data-overcategory-nav]');
  if (!nav) return;

  const isDesktop = window.matchMedia('(min-width: 1000px)').matches;

  const tab = event.target.closest('.overcategory-nav__tab');
  if (tab) {
    const target = tab.getAttribute('data-panel-target');

    nav.querySelectorAll('.overcategory-nav__tab').forEach((button) => {
      const active = button === tab;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    nav.querySelectorAll('[data-root-panel]').forEach((panel) => {
      panel.classList.toggle('is-active', panel.getAttribute('data-panel') === target);
    });

    closeAllDesktopSubpanels(nav);
    closeAllMobileSubpanels(nav);
    return;
  }

  const trigger = event.target.closest('[data-mobile-subpanel-target], [data-desktop-subpanel-target]');
  if (trigger) {
    const target =
      trigger.getAttribute('data-mobile-subpanel-target') ||
      trigger.getAttribute('data-desktop-subpanel-target');

    if (isDesktop) {
      const currentRoot = trigger.closest('[data-root-panel]');
      const shell = trigger.closest('.overcategory-nav__desktop-shell');
      const drawer = document.getElementById('header-sidebar-menu');

      if (!currentRoot || !shell) return;

      shell.classList.add('has-active-subpanel');

      if (drawer) {
        drawer.classList.add('has-active-subpanel');
      }

      currentRoot.querySelectorAll('[data-desktop-subpanel-target]').forEach((button) => {
        button.classList.toggle('is-active', button === trigger);
      });

      currentRoot.querySelectorAll('[data-desktop-subpanel]').forEach((panel) => {
        panel.classList.toggle(
          'is-active',
          panel.getAttribute('data-desktop-subpanel') === target
        );
      });
    } else {
      nav.querySelectorAll('[data-root-panel]').forEach((panel) => {
        panel.classList.remove('is-active');
      });

      nav.querySelectorAll('[data-mobile-subpanel]').forEach((panel) => {
        panel.classList.toggle(
          'is-active',
          panel.getAttribute('data-mobile-subpanel') === target
        );
      });
    }

    return;
  }

  const backButton = event.target.closest('[data-back-target]');
  if (backButton) {
    const target = backButton.getAttribute('data-back-target');

    closeAllMobileSubpanels(nav);

    nav.querySelectorAll('[data-root-panel]').forEach((panel) => {
      panel.classList.toggle('is-active', panel.getAttribute('data-panel') === target);
    });
  }
});

(function () {
  const drawer = document.getElementById('header-sidebar-menu');
  if (!drawer) return;

  const observer = new MutationObserver(() => {
    const isOpen =
      drawer.hasAttribute('open') ||
      drawer.matches('[open]') ||
      drawer.getAttribute('aria-hidden') === 'false';

    if (!isOpen) {
      resetDrawerPanels(drawer);
    }
  });

  observer.observe(drawer, {
    attributes: true,
    attributeFilter: ['open', 'aria-hidden']
  });
})();